import "../css/cover-spin.css";

const Loading = () => {
  return <div id="cover-spin"></div>;
};

export default Loading;
